import React, {createRef, useRef} from 'react';
import type {TextFieldProps} from '@material-ui/core';
import {TextField, withStyles} from '@material-ui/core';
import {FieldTextStyles} from 'assets/tss/layouts/components';

const EfeFieldText = (props: TextFieldProps) => {
    const {helperText, value} = props;
    return (
        <TextField
            color='secondary'
            InputLabelProps={{
                shrink: true,
            }}
            helperText={helperText || ' '}
            value={value ? value : ''}
            {...props}
        />
    );
};

export default withStyles(FieldTextStyles)(EfeFieldText);
